<template>
  <div class="mt-6 container-fluid">
        <!-- <div class="row min-vh-80"> -->
            <div class="col-12">
                <h3 class="text-center pb-3">Contacts</h3>
                <!-- <p class="lead font-weight-normal opacity-8 mb-5 text-center">
                    Manage your contacts to easily share files with them.
                </p> -->
                        
                <div v-if="isLoadingContacts" class="d-flex justify-content-center align-items-center" style="min-height: 60vh;">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
        
                <div v-else>
                    <div v-if="contactList.length > 0" class="row">
                        <div class="col">
                            <div class="input-group-text bg-white border-end-0 border-radius-lg" style="max-width: 400px; height: 40px;">
                                <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" class="mx-2" />
                                <input
                                    id="search"
                                    v-model="searchQuery"
                                    placeholder="Search here..."
                                    class="form-control border-start-0 contact-field"
                                />
                            </div>
                        </div>
                            
                        <div class="col-auto">
                            <button
                                type="button"
                                class="btn btn-shareguard fab-button"
                                aria-label="Add Contact"
                                @click="openAddContactModal"
                            >
                                <FontAwesomeIcon icon="fa-solid fa-plus" />
                            </button>
                        </div>
                    </div>
            
                    <div v-if="filteredContacts && filteredContacts.length > 0" class="row">
                        <div v-for="filteredContact in filteredContacts" :key="filteredContact.email" class="mt-4 mb-2 col-lg-4 col-md-6">
                            <contact-card
                                :contact="filteredContact"
                                @open-share-files-modal="() => openShareFilesModal(filteredContact)"
                                @open-edit-contact-modal="() => openEditContactModal(filteredContact)"
                                @open-delete-contact-modal="() => openDeleteContactModal(filteredContact)"
                                @contact-invited="() => contactInvited(filteredContact)"
                            ></contact-card>
                        </div>
                    </div>
                    <div v-else>
                        <EmptyStateContacts 
                            :add-contact="openAddContactModal"
                            @add-contact="openAddContactModal"
                        />
                    </div>
                </div>

                <AddContactModal
                    v-if="showAddContactModal"
                    @close-add-contact-modal="resetValues"
                />

                <EditContactModal
                    v-if="showEditContactModal"
                    :contact="selectedContact"
                    @close-edit-contact-modal="resetValues"
                />

                <ShareFilesModal
                    v-if="showShareFilesModal"
                    :contact="selectedContact"
                    @close-share-files-modal="resetValues"
                />

                <DeleteContactModal
                    v-if="showDeleteContactModal"
                    :contact="selectedContact"
                    @close-delete-contact-modal="resetValues"
                />
            </div>
        <!-- </div> -->
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import ContactCard from "./ContactCard.vue";
import AddContactModal from "./AddContactModal.vue";
import EditContactModal from "./EditContactModal.vue";
import ShareFilesModal from "../files/ShareFilesModal.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import EmptyStateContacts from "./EmptyStateContacts.vue";
import DeleteContactModal from "./DeleteContactModal.vue";
import setNavPills from "../../assets/js/nav-pills";

export default {
    name: 'ContactList',
    components: {
        ContactCard,
        FontAwesomeIcon,
        EmptyStateContacts,
        AddContactModal,
        ShareFilesModal,
        EditContactModal,
        DeleteContactModal
    },
    data() {
        return {
            searchQuery: '',
            showAddContactModal: false,
            showShareFilesModal: false,
            showEditContactModal: false,
            showDeleteContactModal: false,
            selectedContact: null
        };
    },
    computed: {
        ...mapState("contacts", ["contactList"]),
        ...mapGetters("contacts", ["isLoadingContacts"]),

        filteredContacts() {
            if (!this.searchQuery) return this.contactList; // Return full list if search is empty
            
            return this.contactList.filter(contact =>
                contact.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                contact.email.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        }
    },
    async mounted() {
        setNavPills();
        this.fetchContactList();
    },
    methods: {
        ...mapActions("contacts", ["fetchContactList", "inviteContactAction"]),
        openAddContactModal() {
            this.showAddContactModal = true;
        },
        openEditContactModal(selectedContact) {
            this.selectedContact = selectedContact;
            this.showEditContactModal = true;
        },
        openDeleteContactModal(selectedContact) {
            this.selectedContact = selectedContact;
            this.showDeleteContactModal = true;
        },
        openShareFilesModal(selectedContact) {
            this.selectedContact = selectedContact;
            this.showShareFilesModal = true;
        },
        contactInvited(selectedContact) {
            selectedContact.invited = true;
            this.selectedContact = selectedContact;

            this.inviteContactAction(selectedContact);
            
        },
        resetValues() {
            this.showAddContactModal = false;
            this.showShareFilesModal = false;
            this.showEditContactModal = false;
            this.showDeleteContactModal = false;
            this.selectedContact = null;
        },
    }
}
</script>

<style>
.contact-field {
    border: 1px solid rgb(229, 231, 235);
    padding: 0.5rem 1rem;
    height: 38px;
}

.input-group-text {
    border: 1px solid rgb(229, 231, 235);
    border-right: none;
    padding: 0.5rem 1rem;
}

.input-group .form-control {
    border-left: none;
}

.input-group .form-control:focus {
    box-shadow: none;
    border-color: rgb(229, 231, 235);
}

.contact-row:hover {
  transform: scale(1.02);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 0.5rem;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  z-index: $zindex-modal-content;
}

.fab-button {
    width: 40px !important;
    height: 40px !important;
    aspect-ratio: 1/1;
    border-radius: 50% !important;
    padding: 0 !important;
    margin: 0 !important;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    line-height: 1;
    vertical-align: middle;
}

.col-auto .fab-button {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
    min-height: 40px !important;
    max-width: 40px !important;
    max-height: 40px !important;
}

.fab-button:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.fab-button svg {
    font-size: 1.25rem;
    display: block;
    margin: 0 auto;
    line-height: 1;
    vertical-align: middle;
}

</style>